import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { Task } from 'src/app/helpers/task';

@Component({
    selector: 'tcm-tab-layout',
    templateUrl: './tcm-tab-layout.component.html',
    styleUrls: ['./tcm-tab-layout.component.scss'],
    standalone: false
})
export class TcmTabLayoutComponent {

    @Input() titleKey: string;

    @Input() useAdvancedSearch: boolean = false;

    showRightSidebar: boolean;

    @ViewChild('rightSideBarContainer', { static: true }) rightSideBarContainer: ElementRef<HTMLElement>;

    async toggleRightSideBar($event: Event) {
        $event.stopPropagation();

        this.showRightSidebar = !this.showRightSidebar;

        if (this.showRightSidebar) {
            await Task.delay(600);
        }
        
        if (this.showRightSidebar) {
            this.rightSideBarContainer.nativeElement.classList.add('omit-overflow');
        }
        else {
            this.rightSideBarContainer.nativeElement.classList.remove('omit-overflow');
        }
    }
}
